// extracted by mini-css-extract-plugin
module.exports = {"text":"RecaptchaInfo-module__text___1lUBz"};